// Généré par maquettes/outils/dc2react.py à partir de la maquette. Ne pas modifier à la main :
// changer maquettes/src puis relancer le script.
import React from 'react';

export default function Contact({ v }) {
  return (
    <section id="rdv" style={{ background: v.accent, color: "#FFFFFF" }}>
      <div className="m-sec" style={{ maxWidth: "1240px", margin: "0 auto", padding: "88px 24px", display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "32px" }}>
        <div style={{ flex: "1 1 520px", minWidth: "0", display: "flex", flexDirection: "column", gap: "12px" }}>
          <h2 style={{ margin: "0", fontSize: "clamp(34px, 4vw, 58px)", fontWeight: "800", fontStretch: "78%", lineHeight: "1.0" }}>
            Quel outil manque à votre équipe ?
          </h2>
          <p style={{ margin: "0", fontSize: "18px", maxWidth: "560px" }}>
            30 minutes pour en parler, puis un prix fixe par écrit sous 3 jours.
          </p>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "flex-start" }}>
          <a href="https://calendly.com/hello-autoria/30min?utm_source=autoria.dev&utm_medium=site&utm_content=bas-de-page" target="_blank" rel="noopener" className="lift" style={{ display: "inline-flex", alignItems: "center", minHeight: "56px", padding: "14px 28px", background: "#FFFFFF", color: "#15171A", textDecoration: "none", fontWeight: "800", fontSize: "18px", borderRadius: "4px" }}>
            Réserver mon appel
          </a>
          <a href="/diagnostic" style={{ color: "#FFFFFF", fontWeight: "600", fontSize: "15px" }}>
            ou décrivez votre besoin en 1 minute
          </a>
          <a href="/outils" style={{ color: "#FFFFFF", fontWeight: "600", fontSize: "15px" }}>
            ou essayez les calculateurs gratuits
          </a>
          <a href="mailto:hello@autoria.dev" style={{ color: "#FFFFFF", fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "14px" }}>
            hello@autoria.dev
          </a>
        </div>
      </div>
    </section>
  );
}
